import { StyleSheet } from 'aphrodite/no-important';
import { baseUnit } from '../../../theming/baseUnitDefinition';


export const createStyles = (color: string) => {
  return StyleSheet.create({
    root: {
      marginTop: baseUnit,
    },
    titleWrapper: {
      paddingRight: '10px',
      paddingLeft: baseUnit,
    },
    sectionDivider: {
      border: `1px solid ${color}`,
      margin: baseUnit,
      marginTop: '10px',
    },
    articlesWrapper: {
      padding: '0 20px',
      color,
    },
    articleItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      color,
    },
    circle: {
      color,
      marginRight: '8px',
    },
    articleWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
  });
};
